import { CirclePlay, Rocket } from "../ui";

export const ALL_SECTIONS = [
  { key: "videos", icon: CirclePlay, label: { ar: "الفيديوهات", en: "Videos" } },
  { key: "payments", icon: Rocket, label: { ar: "تطبيقات التوصيل", en: "Delivery Apps" } },
];

// Branch users only see the Videos section (the backend also closes the rest).
const BRANCH_SECTION_KEYS = ["videos"];

export const BRANCH_SECTIONS = ALL_SECTIONS.filter((section) =>
  BRANCH_SECTION_KEYS.includes(section.key)
);
